var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pl-12 pr-12", attrs: { fluid: "" } },
    [
      _c(
        "v-layout",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isLoading && !_vm.isAvailable,
              expression: "!isLoading && !isAvailable"
            }
          ],
          attrs: { column: "", wrap: "" }
        },
        [
          _c("p", { staticClass: "mt-2" }, [
            _vm._v(_vm._s(_vm.$t("description.salesNotFound")))
          ]),
          _c(
            "v-btn",
            {
              staticClass: "font-weight-black float-right mr-4",
              staticStyle: { "font-size": "20px" },
              attrs: {
                width: "70vw",
                "max-width": "350px",
                color: "next",
                dark: ""
              },
              on: {
                click: function($event) {
                  return _vm.onClickBackHomeButton()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("button.backHome")))]
          )
        ],
        1
      ),
      _c(
        "v-layout",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isLoading && _vm.isAvailable,
              expression: "!isLoading && isAvailable"
            }
          ],
          attrs: { column: "", wrap: "" }
        },
        [
          _c(
            "v-row",
            [
              _c("v-col", [
                _c(
                  "p",
                  {
                    staticClass: "font-weight-black pl-3",
                    staticStyle: { "font-size": "32px" }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("title.agency.salesDetail")) +
                        "\n        "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _c("v-row", [
            _c(
              "p",
              {
                staticClass: "pl-5",
                staticStyle: { "word-wrap": "break-all", "max-width": "90vw" }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("description.salesDetailTop.explanation1")) +
                    "\n      "
                )
              ]
            )
          ]),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                [
                  _c(
                    "v-row",
                    [
                      _c("v-col", { staticClass: "pb-0" }, [
                        _c(
                          "p",
                          {
                            staticClass: "pl-5 mt-3 mb-0 font-weight-black",
                            staticStyle: { "font-size": "20px" }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("label.salesInfo")) +
                                "\n            "
                            )
                          ]
                        )
                      ]),
                      _c(
                        "v-col",
                        { staticClass: "pb-0" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "font-weight-black float-right",
                              staticStyle: { "font-size": "20px" },
                              attrs: {
                                slot: "activator",
                                align: "center",
                                width: "70vw",
                                "max-width": "250px",
                                color: "next",
                                dark: _vm.isSalesEditButtonEnabled,
                                disabled: !_vm.isSalesEditButtonEnabled
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onClickEditSalesButton()
                                }
                              },
                              slot: "activator"
                            },
                            [_vm._v(_vm._s(_vm.$t("button.salesEdit")))]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "pb-0" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "font-weight-black float-right",
                              staticStyle: { "font-size": "20px" },
                              attrs: {
                                align: "center",
                                width: "70vw",
                                "max-width": "250px",
                                color: "next",
                                dark: _vm.isSalesDeleteButtonEnabled,
                                disabled: !_vm.isSalesDeleteButtonEnabled
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onClickSalesDeleteButton()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("button.salesDelete")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-simple-table",
                    {
                      staticClass:
                        "elevation-1 v_base_table_fill_width v_base_table_with_border",
                      staticStyle: { width: "100%" }
                    },
                    [
                      _c(
                        "tbody",
                        _vm._l(_vm.salesRecords, function(salesRecord) {
                          return _c("tr", { key: salesRecord.key }, [
                            _c(
                              "td",
                              {
                                staticClass:
                                  "text-left .v_base_table_with_border base_td_category_text"
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t(
                                        "header.salesListTable." +
                                          salesRecord.key
                                      )
                                    ) +
                                    "\n              "
                                )
                              ]
                            ),
                            _c("td", [_vm._v(_vm._s(salesRecord.value))])
                          ])
                        }),
                        0
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          !_vm.isAgency() && _vm.sales.id
            ? _c("SalesConnection", { attrs: { salesId: _vm.sales.id } })
            : _vm._e(),
          _c("FormsDialog", {
            attrs: {
              showDialog: _vm.showEditInsuranceDialog,
              title: _vm.$t("title.agency.salesEdit"),
              text: null,
              subText: null,
              negativeButtonTitle: _vm.$t("button.cancel"),
              positiveButtonTitle: _vm.$t("button.update"),
              onClickNegativeButton: _vm.cancelEditInsurance,
              onClickPositiveButton: _vm.updateInsurance,
              targets: _vm.editInsuranceTargets
            }
          }),
          _c("DeleteDialog", {
            ref: "salesDeleteDialog",
            attrs: { title: _vm.$t("title.agency.salesDelete") },
            on: { onSuccess: _vm.onSuccessDeleteInsurance }
          }),
          _c("ErrorDialog", { ref: "errorDialog" }),
          _c("CompletedDialog", { ref: "completedDialog" })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }